<template>
  <div id="app">
    <router-view :key="$route.fullPath" />
    <slideout-panel></slideout-panel>
  </div>
</template>
<script>

  export default {
    name: 'app',
    data() {
      return {}
    },
    // $el 생성전
    created() {
      // 브라우저 로그인 유지
      if (this.storageGet('vuex') && this.storageGet('vuex','authUserSId')){
        this.$store.commit('setUserNum',this.storageGet('vuex','userNum'));
        this.$store.commit('setAuthUserSId',this.storageGet('vuex','authUserSId'));
        this.$store.commit('setUserId',this.storageGet('vuex','userId'));
        this.$store.commit('setUserName',this.storageGet('vuex','userName'));
        this.$store.commit('setUserProfile',this.storageGet('vuex','userProfile'));
        this.$store.commit('setBoardList',this.storageGet('vuex','boardList'));
      }else{
        this.$router.push('/login');
      }
      this.autoLoginFunc();
    },
    methods: {
      autoLoginFunc(){
        let param = {};
        this.ajaxGetAuth('/api/v1/autoLogin', param, this.autoLoginFuncResult);
      },
      autoLoginFuncResult(response) {
        if( response.maintenance){
          alert("정기점검중입니다 \n\n페이지가 이동됩니다.")
          window.location.href="http://noti.mobigo.co.kr";
        }
        this.$store.commit('setMessagesList', response.messages);
      }
    }
  }
</script>
<style lang="scss">
  @import 'assets/style.css';
  @import 'assets/notoKr.css';
  @import 'assets/custom.css';
  @import 'assets/vue-transition.css';
</style>
